import _ from 'lodash';
import globalStore from '$$globalStore';
import projectsModel from '$$projectModel';
import ganttViewModel from '$$ganttViewModel';
import prepareColumnValue from './prepareColumnValue';

export default function (ganttTask, column) {
  const ganttId = ganttTask.gantt_id || projectsModel.getActiveGanttId();
  const taskTypesForColumn = ['project', 'task', 'milestone'];
  let result = {
    text: '',
    value: null,
    toExcel: '',
  };

  if (!_.includes(taskTypesForColumn, ganttTask.type) || !ganttTask.parent) {
    return result;
  }

  const baselineUserCustomValue = globalStore.getters['baselines/getActiveBaselineUserCustomValues'](ganttId, column.name, ganttTask.id);
  const baselineData = globalStore.getters['baselines/getActiveBaselineData'](ganttId);

  if (baselineData && !ganttViewModel.isMultiview()) {
    let columnData = _.find(baselineData.userCustomColumnsData.columns, { id: column.name });

    if (!columnData) {
      columnData = globalStore.getters['columns/getCustomColumnById'](column.name);
    } else {
      columnData.type = columnData.custom_column_types_id;
      columnData.sub_type = columnData.custom_column_sub_types_id;
    }

    result = prepareColumnValue(result, ganttTask, columnData, baselineUserCustomValue, true);
  }

  return result;
}
